/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import CopyProvider from '../../utils/copy-provider';
import cy from '../../copies/cy.json';
import en from '../../copies/en.json';
import { getCookie, setCookie } from '../../utils/cookieUtils';

const cyCopy = {
  cy,
};

const enCopy = {
  en,
};

const initialState = {
  currentUserAccount: null,
  dashboardLink: null,
  currentLanguage: !getCookie('lang') ? 'en' : getCookie('lang'),
  copyProviderCY: new CopyProvider('cy', cyCopy, 'nested'),
  copyProviderEN: new CopyProvider('en', enCopy, 'nested'),
  DateOfAccessibilityTest: '16 September 2022', // a hard coded value for now, this doesn't need a setter.
  dateOfPreparedTest: '22 September 2022', // hard coded value, no setter required
  lastReviewedDate: '26 September 2022', // hard coded vale, no setter required
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setCurrentUserAccount: (state, action) => {
      state.currentUserAccount = action.payload;
    },
    setDashboardLink: (state, action) => {
      state.dashboardLink = action.payload;
    },
    setCurrentLanguage: (state, action) => {
      state.currentLanguage = action.payload;
      setCookie('lang', action.payload, 1);
    },
  },
});

export const { setCurrentUserAccount, setDashboardLink, setCurrentLanguage } =
  appSlice.actions;

export const getCurrentUserAccount = (state) => state.app.currentUserAccount;
export const getDashboardLink = (state) => state.app.dashboardLink;
export const getCurrentLanguage = (state) => state.app.currentLanguage;
export const getCopyProviderCY = (state) => state.app.copyProviderCY;
export const getCopyProviderEN = (state) => state.app.copyProviderEN;
export const getDateOfAccessibilityTest = (state) =>
  state.app.DateOfAccessibilityTest;
export const getDateOfPreparedTest = (state) => state.app.dateOfPreparedTest;
export const getLastReviewedDate = (state) => state.app.lastReviewedDate;

export default appSlice.reducer;
